import { RolePermissions } from '../../users/hooks/useRoleAccess';
import WorkflowSection from './WorkflowSection';
import TodaysAppointments from './TodaysAppointments';
import BusinessStatsOverview from './BusinessStatsOverview';
// import WorkflowTrends from './WorkflowTrends';
// import PerformanceMetricsDashboard from './PerformanceMetricsDashboard';

interface User {
  id: string;
  email: string;
  role?: string;
  fullName?: string;
}

interface AdminDashboardContentProps {
  user: User;
  permissions: RolePermissions;
}

export default function AdminDashboard({ permissions }: Readonly<AdminDashboardContentProps>) {
  return (
    <div className="w-full max-w-full overflow-x-hidden space-y-6">
      {/* Workflow Section */}
      {permissions.canViewJobs && <WorkflowSection />}
      
      {/* Today's Appointments */}
      {permissions.canViewJobs && <TodaysAppointments />}
      
      {/* Service Provider Statistics */}
      {(permissions.canViewReports || permissions.canManageSettings) && (
        <BusinessStatsOverview />
      )}
      
      {/* Enhanced Trends and Analytics
      {(permissions.canViewFinancial || permissions.canViewReports) && (
        <WorkflowTrends />
      )} */}
      
      {/* Performance Metrics Dashboard
      {permissions.canManageSettings && (
        <PerformanceMetricsDashboard />
      )} */}
    </div>
  );
}
